import React from 'react';
import Routes from '../../../consts/Routes';
import './WikiSearchField.less';

interface Props {
  detailId: string;
  searchingWiki: boolean;
}

//field that's highlighted when 'search what you click' is enabled. when highlighted
//area is clicked, open corrisponding wiki page in a new tab.
const WikiSearchField = (props: React.PropsWithChildren<Props>) => {
  return (
    <span
      className={props.searchingWiki ? 'wiki-search-field' : undefined}
      onClick={(e) => {
        if (props.searchingWiki) {
          e.stopPropagation(); //stop other on click events that would happen when clicking the element with 'search what you click' disabled
          window.open(
            Routes.generate(Routes.RoutesList.WIKI_DETAIL.Path, { id: props.detailId }),
            '_blank',
            'noopener,noreferrer'
          );
        }
      }}
    >
      {props.children}
    </span>
  );
};

export default WikiSearchField;
